module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-operation__register"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "registerForm",
    staticClass: "user-operation__register-form",
    attrs: {
      "label-width": "0",
      "model": _vm.registerFormModel,
      "rules": _vm.rules
    }
  }, [(_vm.isInviteCodeRegister) ? _c('el-form-item', {
    ref: "inviteCode",
    attrs: {
      "prop": "inviteCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邀请码",
      "maxlength": 30
    },
    on: {
      "change": _vm.allowSendingVerifyCode,
      "blur": function($event) {
        return _vm.inputBlurFn('inviteCode')
      }
    },
    model: {
      value: (_vm.registerFormModel.inviteCode),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "inviteCode", $$v)
      },
      expression: "registerFormModel.inviteCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    ref: "cellphone",
    attrs: {
      "prop": "cellphone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号",
      "maxlength": 11
    },
    on: {
      "change": _vm.allowSendingVerifyCode,
      "blur": function($event) {
        return _vm.inputBlurFn('cellphone')
      }
    },
    model: {
      value: (_vm.registerFormModel.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "cellphone", $$v)
      },
      expression: "registerFormModel.cellphone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "registerPassword",
    attrs: {
      "prop": "registerPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "maxlength": 16
    },
    on: {
      "change": _vm.allowSendingVerifyCode,
      "blur": function($event) {
        return _vm.inputBlurFn('registerPassword')
      }
    },
    model: {
      value: (_vm.registerFormModel.registerPassword),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "registerPassword", $$v)
      },
      expression: "registerFormModel.registerPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    ref: "confirmRegisterPassword",
    attrs: {
      "prop": "confirmRegisterPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码",
      "maxlength": 16
    },
    on: {
      "change": _vm.allowSendingVerifyCode,
      "blur": function($event) {
        return _vm.inputBlurFn('confirmRegisterPassword')
      }
    },
    model: {
      value: (_vm.registerFormModel.confirmRegisterPassword),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "confirmRegisterPassword", $$v)
      },
      expression: "registerFormModel.confirmRegisterPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "user-operation__sms-validate-code",
    attrs: {
      "prop": "SMSVerificationCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入短信验证码",
      "disabled": _vm.isAllowSendingVerifyCode,
      "maxlength": 6
    },
    on: {
      "blur": function($event) {
        return _vm.inputBlurFn('SMSVerificationCode')
      }
    },
    model: {
      value: (_vm.registerFormModel.SMSVerificationCode),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "SMSVerificationCode", $$v)
      },
      expression: "registerFormModel.SMSVerificationCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "user-operation__sms-button",
    attrs: {
      "type": "primary",
      "size": "mini",
      "loading": _vm.isLoading,
      "disabled": _vm.SMSVerificationCodeBtn.disabled
    },
    on: {
      "click": _vm.getSMSVerificationCode
    }
  }, [_vm._v("\n        " + _vm._s(_vm.SMSVerificationCodeBtn.text) + "\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0 text-right"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.registerFormModel.userType),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "userType", $$v)
      },
      expression: "registerFormModel.userType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("个人")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0 text-left",
    attrs: {
      "prop": "hasReadContract"
    }
  }, [_c('el-checkbox', {
    staticClass: "user-operation__has-read-register-contract",
    model: {
      value: (_vm.registerFormModel.hasReadContract),
      callback: function($$v) {
        _vm.$set(_vm.registerFormModel, "hasReadContract", $$v)
      },
      expression: "registerFormModel.hasReadContract"
    }
  }, [_vm._v("\n        我已阅读并同意\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "user-operation__show-register-contract",
    on: {
      "click": _vm.showRegisterContract
    }
  }, [_vm._v("\n        《注册须知》")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "user-operation__register-submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isRegistering
    },
    on: {
      "click": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm($event)
      }
    }
  }, [_vm._v("\n    注册\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "user-operation__title"
  }, [_c('span', [_vm._v("注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5779f3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Register.vue
// module id = 1036
// module chunks = 1